import qs from "qs";
const qsOptions = {
    encodeValuesOnly: true,
    strictNullHandling: true,
    skipNulls: true,
    allowDots: true
};
function buildUrlFromTemplate(url, queryParameters = {}, bodyParameters = {}) {
    const [urlWithoutQuery, previousQueryString] = url.split('?');
    const query = qs.parse(previousQueryString);
    let newUrl = urlWithoutQuery;
    if (null != queryParameters && 'object' == typeof queryParameters && !Array.isArray(queryParameters)) {
        const templateVariables = Object.keys(queryParameters).filter((k)=>newUrl.includes(`{${k}}`) || newUrl.includes(`{*${k}}`));
        const queryStringVariables = Object.keys(queryParameters).filter((k)=>!templateVariables.includes(k));
        if (queryStringVariables.length > 0) for (const key of queryStringVariables)query[key] = queryParameters[key];
        for (const key of templateVariables){
            const value = queryParameters[key];
            newUrl = 'object' == typeof value ? newUrl.replace(`{${key}}`, encodeURIComponent(JSON.stringify(value))).replace(`{*${key}}`, encodeURIComponent(JSON.stringify(value))) : newUrl.replace(`{${key}}`, encodeURIComponent(value)).replace(`{*${key}}`, value);
        }
    }
    for (const key of Object.keys(bodyParameters))if (bodyParameters[key] instanceof Object) {
        const bodyObject = bodyParameters[key];
        for (const bodyObjectKey of Object.keys(bodyObject))newUrl = bindRouteValue(newUrl, bodyObject, bodyObjectKey);
    } else newUrl = bindRouteValue(newUrl, bodyParameters, key);
    const newQueryString = qs.stringify(query, qsOptions);
    if ('' !== newQueryString) return `${newUrl}?${newQueryString}`;
    return newUrl;
}
function bindRouteValue(url, object, key) {
    const value = object[key];
    const template = `{${key}}`;
    if (url.includes(template)) {
        delete object[key];
        return url.replace(template, value);
    }
    return url;
}
export { buildUrlFromTemplate };
